export default __webpack_public_path__ + "static/media/rgames.6076ae70.png";